import { useTranslation } from 'react-i18next';
import CheckboxSelect from 'src/UtilComponents/CheckboxSelect';
import type { User } from 'src/types';
import './ProjectUserAccess.css';

interface ProjectUserAccessProps {
  users: User[];
  // IDs of users that currently have access (project_ids includes this project).
  accessUserIds: string[];
  // Called when a user is granted/revoked access.
  onToggle: (userId: string, hasAccess: boolean) => void;
  isSaving?: boolean;
}

const ProjectUserAccess = ({
  users,
  accessUserIds,
  onToggle,
  isSaving = false,
}: ProjectUserAccessProps) => {
  const { t } = useTranslation();

  const options = users.map((u) => ({ id: u.id, name: u.name || u.email }));
  const current = new Set(accessUserIds);

  const handleChange = (selected: string[]) => {
    const next = new Set(selected);
    // Grant: in next, not in current.
    for (const id of next) {
      if (!current.has(id)) onToggle(id, true);
    }
    // Revoke: in current, not in next.
    for (const id of current) {
      if (!next.has(id)) onToggle(id, false);
    }
  };

  return (
    <div className="project-user-access">
      <label className="project-user-access-label">
        {t('management.project.accessUsers')}
        {isSaving && (
          <span className="project-user-access-saving"> · {t('management.saving')}</span>
        )}
      </label>
      {users.length === 0 ? (
        <p className="project-user-access-empty">{t('management.noData')}</p>
      ) : (
        <CheckboxSelect options={options} selectedOptions={accessUserIds} onChange={handleChange} />
      )}
    </div>
  );
};

export default ProjectUserAccess;
